/// <reference path='../../../../../typings/index.d.ts' />

module Meevo.TaxItems {

    interface TaxItemsTypes {
        items: Model.TaxItem[],
        types: Model.TaxType[],
        taxModel: any;
    }
    const MAX_TAX_TYPES = 4;
    export class TaxItemsController {

        static $inject = [
            '$scope',
            '$mdDialog',
            '$mdSidenav',
            '$translate',
            'tax',
            "meevo.components.modal.ModalService"
        ];

        constructor(
            private $scope: ng.IScope,
            private $mdDialog: angular.material.IDialogService,
            protected $mdSidenav: ng.material.ISidenavService,
            private $translate: angular.translate.ITranslateService,
            private tax: TaxItemsTypes,
            private modalService: Meevo.Components.Modal.IModalService

        ) {
            _.each(this.tax.items, (item) => {
                item['show'] = item.isActive == false
            });
        }

        confirm = (answer: boolean | TaxItemsTypes) => {
            this.$mdDialog.hide(answer);
        }

        isAddTaxTypeDisable = (): boolean => {
            let result = _.filter(this.tax.taxModel["taxTypes"], (r: any) => { return r.isActive === true })
            return result.length > MAX_TAX_TYPES;
        }
        isAddTaxTypeAvailable = (): boolean => {
            let result = _.filter(this.tax.taxModel["taxTypes"], (r: any) => { return r.isActive === true })
            return result.length > 5 ;
        }

        parseTaxItemRates(taxItemRates: Model.TaxItemRate[]) {
            let parsedTaxItemRates = '';
            _.each(taxItemRates, (rate: any) => {
                parsedTaxItemRates += `${rate.displayName}: ${(rate.taxRate * 100).toFixed(2)}%, `
            })

            return parsedTaxItemRates.slice(0, -2);
        }

        parseTaxTypesRates(taxtype: Model.TaxType) {

            let parsedTaxTypeRates = '';
            _.each(this.tax.items, (item: Model.TaxItem) => {
                parsedTaxTypeRates += `${item.displayName}: ${(item.taxItemRates.filter(rate => rate.taxType_LId.toString() == taxtype.id)[0].taxRate * 100).toFixed(2)}%, `
            })

            return parsedTaxTypeRates.slice(0, -2);
        }

        enumValueOf(value: number) {
            return Meevo.Model.TaxItemTypeEnum[value];
        }

        isDisplayNameUnique = (collection: string, item: any) => {
            if (item.displayName == null) return;
            if (this.isAddTaxTypeAvailable() && collection == "taxTypes") {
                item.isActive = false;
            //   // this.modalService.alert("MESSAGE_ACTIVE_TAXTYPE_LIMIT", 0, true);
              }
            let itemFound = _.filter(this.tax.taxModel[collection], (i: any) => { return i.displayName == null ? false : i.displayName.toLowerCase() == item.displayName.toLowerCase(); });
            if (itemFound.length > 1) {
                let message = this.$translate.instant("LABEL_TAX_DUPLICATE_NAME", { name: item.displayName });
                this.modalService.alert(message, 1, true)
                    .then((res) => {
                        if (collection == "taxTypes") {

                            let id = item.taxType_LId;
                            let member: any = _.filter(this.tax.taxModel[collection],
                                (i: any) => { return i.id === id })[0];
                            if (Model.Guard.isSomething(member))
                                this.tax.taxModel[collection][member.sortOrder - 1].isActive = false;
                        } else {
                            let id = item.sortOrder;
                            let member: any = _.filter(this.tax.taxModel[collection],
                                (i: any) => { return i.sortOrder === id })[0];
                            if (Model.Guard.isSomething(member))
                                this.tax.taxModel[collection][member.sortOrder - 1].isActive = false;
                        }
                    });
            }
        }

    }

    angular.module('meevo')
        .controller('meevo.TaxItems.taxItemsController', TaxItemsController);
}